import {Controller} from "@hotwired/stimulus"
import moment from "moment";
import "bootstrap-datepicker"

export default class extends Controller {
  static values = {
    refreshUrl: String,
  };

  static targets = [
    "dateOfOrder",
    "startDate",
    "endDate"
  ];

  connect() {
    $(document).ready(() => {
      $(this.dateOfOrderTarget).datepicker().on('change', this.refreshFormData.bind(this));
      $(this.endDateTarget).datepicker().on('change', this.refreshFormData.bind(this));
      $(this.startDateTarget).datepicker().on('change', this.refreshFormData.bind(this));
    });
  }

  disconnect() {
    $(this.dateOfOrderTarget).datepicker().off('change', this.refreshFormData.bind(this));
    $(this.endDateTarget).datepicker().off('change', this.refreshFormData.bind(this));
    $(this.startDateTarget).datepicker().off('change');
  }

  refreshFormData(event) {
    const element = $(event.target);
    const formElement = element.closest('form');
    const refreshUrl = formElement.data('refreshUrlValue')


    $.ajax({
      type: 'GET',
      url: refreshUrl,
      data: formElement.serialize(),
      dataType: 'script'
    });
  }

}
